// Hook form
import { Control, FieldValues, RegisterOptions } from "react-hook-form";
// Material
import { FormControlLabelProps } from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
// Say Lib
import HookCheckbox from "../HookCheckbox";

type GroupOption = {
  name: string;
  label: string;
};

export type IHookCheckboxGroup = Omit<
  FormControlLabelProps,
  "control" | "label"
> & {
  formGroupOptions: GroupOption[];
  control?: Control<FieldValues>;
  name: string;
  defaultValue?: string | undefined;
  rules?: Omit<
    RegisterOptions<FieldValues>,
    "valueAsNumber" | "valueAsDate" | "setValueAs"
  >;
  validationArr?: string[];
};

/**
 * @param formGroupOptions - list of checkbox items
 * @param control - control from useForm (react-hook-form)
 * @param name - field name
 * @returns JSX.Element
 */
const HookCheckboxGroup = ({
  formGroupOptions = [],
  control,
  name,
  ...rest
}: IHookCheckboxGroup): JSX.Element => {
  return (
    <div>
      <FormGroup>
        {formGroupOptions.map((opt) => {
          return (
            <HookCheckbox
              key={opt.name}
              control={control}
              name={`${name}.${opt.name}`}
              label={opt.label}
              {...rest}
            />
          );
        })}
      </FormGroup>
    </div>
  );
};

export default HookCheckboxGroup;
